<div class="cr-driver__root-container">
  <div class="cr-driver__root_content">
    <app-header></app-header>
    <div class="cr-driver__content-slot">
      <router-outlet></router-outlet>
    </div>
    <app-footer class="cr-driver_footer"></app-footer>
  </div>
  <pc-status-overlay [small]="true"></pc-status-overlay>
  <app-wattson></app-wattson>
</div>
